import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Components
import { FixedTable } from 'components/content-containers/tables';
import ExpenseBill from './expense-bill';


// Component
export default function ExpenseBills({ purchaseOrder }) {
  const expenseBills = _.filter(_.orderBy(purchaseOrder.expenseBills, bill => moment(bill.date).toDate(), 'desc'), { returnFor: null });
  const unapprovedExpenseBills = purchaseOrder.unapprovedExpenseBills;

  if (!expenseBills.length) return null;

  return (
    <FixedTable
      className="charges"
      invisibleHeaders={[
        'col-expense-button',
        'col-duration',
        'col-money',
        'col-money',
        '',
        'col-medium'
      ]}
      headerRow={
        <tr>
          <th colSpan="4">Charges</th>
          <th className="right-align" colSpan="2">
            {`${expenseBills.length - unapprovedExpenseBills}/${expenseBills.length} Approved`}
          </th>
        </tr>
      }
    >
      {_.map(expenseBills, (expenseBill) =>
        <ExpenseBill key={expenseBill.id} expenseBill={expenseBill} purchaseOrder={purchaseOrder} />
      )}
    </FixedTable>
  );
}

ExpenseBills.propTypes = {
  purchaseOrder: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/components/models/purchases/expense-bills.js